import React, { Component } from "react";
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import { isBrowser } from "react-device-detect";
import { Container, Card, Row, Col, Badge } from "react-bootstrap";
import moment from "moment";
import * as compose from "lodash.flowright";
import gql from "graphql-tag";
// Student-app profile styling (sp-* classes) used by the ported tabs.
import "../components/student-profile-1/_student_profile.scss";

// Tab content components — one per tab.
import OverviewTab from "../components/student-profile-1/OverviewTab";
import PerformanceTab from "../components/student-profile-1/PerformanceTab";
import SubjectsTopicsTab from "../components/student-profile-1/SubjectsTopicsTab";
import TimeAnalysisTab from "../components/student-profile-1/TimeAnalysisTab";
import ComplexityAnalysisTab from "../components/student-profile-1/ComplexityAnalysisTab";
// import StudentListSidebar from "../components/student-profile-1/StudentListSidebar";
import PredictionRankTab from "../components/student-profile-1/PredictionRankTab";
import RevisionPlannerTab from "../components/student-profile-1/RevisionPlannerTab";
import DoubtsTab from "../components/student-profile-1/DoubtsTab";
import AtRiskTab from "../components/student-profile-1/AtRiskTab";
import AttendanceTab from "../components/student-profile-1/AttendanceTab";
import FeesTab from "../components/student-profile-1/FeesTab";
import DocumentsTab from "../components/student-profile-1/DocumentsTab";
// Consolidated printable report (profile + attendance + every exam + overall performance).
import {
    fetchStudentReport,
    buildStudentReportHTML,
    printStudentReportHTML,
    reportFileTitle,
} from "../components/student-profile-1/studentReportDoc";

// Tab configuration — order matches the design.
// Grouped like the student app (Individual Analysis / Records), student-app labels.
const GROUP = { INDIVIDUAL: "Individual Analysis", RECORDS: "Records" };
const TABS = [
    { key: "overview", label: "Overview", group: GROUP.INDIVIDUAL },
    { key: "performance", label: "Marks Trend", group: GROUP.INDIVIDUAL },
    { key: "subjects-topics", label: "Chapter & Topic Accuracy", group: GROUP.INDIVIDUAL },
    { key: "time-analysis", label: "Time per Question", group: GROUP.INDIVIDUAL },
    { key: "complexity-analysis", label: "Complexity", group: GROUP.INDIVIDUAL },
    { key: "prediction-rank", label: "Rank & Prediction", group: GROUP.INDIVIDUAL },
    { key: "revision-planner", label: "Revision Planner", group: GROUP.INDIVIDUAL },
    { key: "doubts", label: "Doubts", group: GROUP.INDIVIDUAL },
    { key: "at-risk", label: "At-Risk", group: GROUP.INDIVIDUAL },
    { key: "attendance", label: "Attendance", group: GROUP.RECORDS },
    { key: "fees", label: "Fees", group: GROUP.RECORDS },
    { key: "documents", label: "Documents", group: GROUP.RECORDS },
];
const GROUP_ORDER = [GROUP.INDIVIDUAL, GROUP.RECORDS];

// Tabs whose entire content is derived from exam attempts. When the student has
// taken no exams there is nothing to compute, so these show a single clear
// "no exams yet" empty state instead of zeros and blank charts.
// Excluded on purpose:
//  - Records tabs (doubts / attendance / fees / documents) are not exam-based.
//  - "at-risk" mixes exam signals WITH attendance, so it can still surface
//    attendance-based risk even with no exams — let it render its own data.
const EXAM_BASED_TABS = new Set([
    "overview",
    "performance",
    "subjects-topics",
    "time-analysis",
    "complexity-analysis",
    "prediction-rank",
    "revision-planner",
]);

// Shared empty state for exam-based tabs when the student has no exam attempts.
const NoExamsState = ({ student, tabLabel }) => (
    <div className="sp-content-card">
        <div className="sp-no-exams">
            <div className="sp-no-exams-ic"><i className="fas fa-clipboard-list" /></div>
            <h5 className="sp-no-exams-title">No exams attempted yet</h5>
            <p className="sp-no-exams-text">
                {(student && student.student_name ? student.student_name : "This student")} hasn't attempted any
                exams, so {tabLabel ? `“${tabLabel}”` : "this"} has nothing to show yet. Analytics will appear here
                automatically once they complete their first exam.
            </p>
        </div>
    </div>
);

// Stream values come from exam_paper.sub_exam_type. Backend LABELS:
// 0 = NEET, 1 = JEE Mains, 2 = JEE Advanced. NEET (0) MUST be included —
// it was previously excluded, so every NEET student fell through to the
// hardcoded "JEE Mains" default and saw the wrong program.
const STREAM_LABELS = { 0: "NEET", 1: "JEE Mains", 2: "JEE Advanced" };
const ALLOWED_STREAMS = [0, 1, 2];
// "All Streams" sentinel. Outside {0,1,2} on purpose: the report backend only
// applies the sub_exam_type filter when exam_stream is 0/1/2, so -1 = no filter.
const ALL_STREAMS = -1;
// NOTE: intentionally NO fallback stream list. The dropdown is driven solely by
// real streams from getStudentExamStreams — a hardcoded NEET/JEE list would show
// options a student doesn't actually have (e.g. a no-exam student).

// A student's own program. student.exam_id: 1 = NEET, 2 = JEE. Map that to the
// sub_exam_type stream so the header shows the right program BEFORE (or without)
// any exam sessions. NEET(exam_id 1) → stream 0; JEE(exam_id 2) → stream 1.
const streamFromStudent = (student) => {
    const examId = Number(student && student.exam_id) || 0;
    if (examId === 1) return 0; // NEET
    if (examId === 2) return 1; // JEE Mains
    // Fall back to profile text hints when exam_id is absent.
    const text = `${(student && (student.exam_name || student.stream_name || student.group || student.group_name || student.section_name)) || ""}`.toLowerCase();
    if (text.includes("neet") || text.includes("bipc") || text.includes("medical")) return 0;
    if (text.includes("jee") || text.includes("mpc")) return 1;
    return 0; // safest default is NEET (the larger population), not JEE
};
const GET_STUDENT_EXAM_STREAMS = gql`
  query ($student_user_id: Int, $edu_student_id: Int) {
    getStudentExamStreams(student_user_id: $student_user_id, edu_student_id: $edu_student_id) {
      stream
      label
      total_exams
      completed
    }
  }
`;
const resolveMobileFor = (student) =>
    (student && (student.contact_no || student.student_mobile || student.mobile)) || null;

class StudentProfile1 extends Component {
    constructor(props) {
        super(props);
        // Default the stream to the VIEWED student's own program (from exam_id),
        // not a hardcoded value — so a NEET student never shows "JEE Mains" while
        // the real stream list loads (or when they have no exams yet).
        const student = (props.location && props.location.state && props.location.state.student) || null;
        const initialStream = streamFromStudent(student);
        this.state = {
            examStream: initialStream,
            // Start EMPTY, never with a fallback list. The stream dropdown renders only
            // from REAL streams returned by the API (getStudentExamStreams). A student
            // with no exams — or one who only ever has a single stream — never sees a
            // dropdown of hardcoded NEET/JEE Mains/JEE Advanced options that aren't hers.
            streamOptions: [],
            streamMenuOpen: false,
            hasExams: null, // null = loading, false = no exams yet, true = has exams
            // Dropdown stays hidden until the real streams resolve (no first-paint flash).
            streamsLoaded: false,
            reportBusy: false, // Student Report is being built (queries + print)
        };
    }

    // The report names the student's OWN program (from exam_id), not the header filter —
    // the document deliberately covers every stream, so quoting the selected filter there
    // would mislabel it.
    reportStreamLabel = () => {
        const own = streamFromStudent(this.getViewedStudent());
        return STREAM_LABELS[own] || null;
    };

    // Build and hand the report straight to the browser's print/Save-as-PDF dialog — no
    // preview step. The queries run on demand (the report covers the student's FULL exam
    // history, which the tabs don't load), so the button shows a busy state meanwhile.
    downloadReport = async () => {
        if (this.state.reportBusy) return;
        const student = this.getViewedStudent();
        if (!student || !this.props.client) return;
        this.setState({ reportBusy: true });
        try {
            // ALL_STREAMS (-1) on purpose: this is the complete record, so it must not
            // inherit the header's stream selection and drop a student's other exams.
            const data = await fetchStudentReport(this.props.client, student, ALL_STREAMS);
            printStudentReportHTML(
                reportFileTitle(student),
                buildStudentReportHTML({ student, data, examStreamLabel: this.reportStreamLabel() })
            );
        } catch (e) {
            console.log(e);
            window.alert("Could not generate the report. Please try again.");
        } finally {
            this.setState({ reportBusy: false });
        }
    };

    componentDidMount() {
        this.fetchStreams();
        document.addEventListener("mousedown", this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleOutsideClick);
    }

    handleOutsideClick = (e) => {
        if (this.state.streamMenuOpen && this.streamRef && !this.streamRef.contains(e.target)) {
            this.setState({ streamMenuOpen: false });
        }
    };

    toggleStreamMenu = () => this.setState((s) => ({ streamMenuOpen: !s.streamMenuOpen }));

    getViewedStudent = () => {
        const { location } = this.props;
        const s = (location && location.state && location.state.student) || null;
        if (!s) return null;
        const studentId = parseInt(s.student_user_id || s.edu_student_id || s.student_id || s.user_id || s.id) || 0;
        const eduStudentId = parseInt(s.edu_student_id || s.student_user_id || s.student_id || s.user_id || s.id) || 0;
        const mobile = s.contact_no || s.student_mobile || s.mobile || s.phone || null;
        return {
            student_user_id: studentId || eduStudentId,
            edu_student_id: eduStudentId || studentId,
            student_name: s.student_name || s.name || s.label,
            contact_no: mobile,
            student_mobile: mobile,
            mobile: mobile,
            ...s,
        };
    };

    fetchStreams = async () => {
        const student = this.getViewedStudent();
        if (!student || !this.props.client) { this.setState({ streamsLoaded: true }); return; }
        try {
            const studentId = parseInt(student.student_user_id || student.edu_student_id || student.student_id || student.user_id || student.id) || 0;
            const eduStudentId = parseInt(student.edu_student_id || student.student_user_id || student.student_id || student.user_id || student.id) || 0;
            const res = await this.props.client.query({
                query: GET_STUDENT_EXAM_STREAMS,
                variables: {
                    student_user_id: studentId,
                    edu_student_id: eduStudentId,
                },
                fetchPolicy: "network-only",
            });
            const rows = (res && res.data && res.data.getStudentExamStreams) || [];
            // Whether the student has attempted ANY exam (any stream with exams).
            // Drives the "no exams yet" empty state on the exam-based tabs.
            const hasExams = rows.some((r) => Number(r.total_exams) > 0);
            const streamOpts = rows
                .filter((r) => ALLOWED_STREAMS.includes(Number(r.stream)) && Number(r.total_exams) > 0)
                // Use the authoritative backend label, falling back to our map.
                .map((r) => ({ value: Number(r.stream), label: r.label || STREAM_LABELS[Number(r.stream)] || "Exam", count: Number(r.total_exams) || 0 }));
            // No stream data (e.g. student hasn't taken any exams): keep the
            // student's own program default set in the constructor — do NOT fall
            // back to a hardcoded stream.
            if (streamOpts.length === 0) {
                this.setState({ hasExams, streamsLoaded: true });
                return;
            }
            // When a student spans MORE THAN ONE stream (e.g. JEE Mains + Advanced),
            // append an "All Streams" option so stream and online/offline mode become
            // independent axes — All Streams lets the exam-performance section see every
            // exam at once, which is what makes the Online/Offline filter appear. It sits
            // LAST because it's a combined view, not the default.
            // ALL_STREAMS value (-1) is intentionally outside {0,1,2}: the backend only
            // applies the sub_exam_type filter for 0/1/2, so -1 means "no stream filter".
            const totalExams = streamOpts.reduce((s, o) => s + (o.count || 0), 0);
            const options = streamOpts.length > 1
                ? [...streamOpts, { value: ALL_STREAMS, label: "All Streams", count: totalExams }]
                : streamOpts;
            // Default to the student's OWN program (clean, per-program KPIs — never
            // blend Mains+Advanced by default). "All Streams" is an explicit choice
            // in the dropdown; only then do both modes combine and the Online/Offline
            // filter appear. Keeps the default view uncluttered and unambiguous.
            let { examStream } = this.state;
            if (!streamOpts.some((o) => o.value === examStream)) {
                const own = streamFromStudent(this.getViewedStudent());
                examStream = streamOpts.some((o) => o.value === own) ? own : streamOpts[0].value;
            }
            this.setState({ streamOptions: options, examStream, hasExams, streamsLoaded: true });
        } catch (e) {
            console.log(e);
            this.setState({ streamsLoaded: true });
        }
    };

    setStream = (examStream) => {
        this.setState({ streamMenuOpen: false });
        if (examStream !== this.state.examStream) this.setState({ examStream });
    };

    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            Cookies.set("toggle", "wrapper");
        }
        this.forceUpdate();
    };

    goToTab = (key) => {
        const { history, location } = this.props;
        history.push({
            pathname: `/student-profile-1/${key}`,
            state: location.state,
        });
    };

    renderTabContent = (activeTab, student) => {
        const mobile = resolveMobileFor(student);
        const p = { student, mobile, examStream: this.state.examStream };
        // Exam-based tab + confirmed no exams → one clear empty state (not zeros /
        // blank charts). hasExams === null means still loading, so let the tab
        // render its own shimmer rather than flashing the empty state.
        if (this.state.hasExams === false && EXAM_BASED_TABS.has(activeTab)) {
            const tab = TABS.find((t) => t.key === activeTab);
            return <NoExamsState student={student} tabLabel={tab && tab.label} />;
        }
        switch (activeTab) {
            case "performance":
                return <PerformanceTab {...p} />;
            case "subjects-topics":
                return <SubjectsTopicsTab {...p} />;
            case "time-analysis":
                return <TimeAnalysisTab {...p} />;
            case "complexity-analysis":
                return <ComplexityAnalysisTab {...p} />;
            case "prediction-rank":
                return <PredictionRankTab {...p} />;
            case "revision-planner":
                return <RevisionPlannerTab {...p} />;
            case "doubts":
                return <DoubtsTab {...p} />;
            case "at-risk":
                return <AtRiskTab {...p} />;
            case "attendance":
                return <AttendanceTab {...p} />;
            case "fees":
                return <FeesTab {...p} />;
            case "documents":
                return <DocumentsTab {...p} />;
            case "overview":
            default:
                return <OverviewTab {...p} />;
        }
    };

    render() {
        if (Cookies.get("token") === undefined) this.props.history.push("/login");

        const { location, match } = this.props;
        const activeTab = (match && match.params && match.params.tab) || "overview";
        const student = this.getViewedStudent();

        const dobValue = student?.dob || student?.date_of_birth;
        let formattedDob = "—";
        if (dobValue) {
            const parsed = moment(dobValue);
            if (parsed.isValid()) {
                const age = moment().diff(parsed, "years");
                formattedDob = `${parsed.format("DD MMM YYYY")} (${age} yrs)`;
            } else {
                formattedDob = dobValue;
            }
        }

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <NavbarOne onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    <div
                        id="sidebar"
                        className={
                            isBrowser === true
                                ? "sidebar-menu d-none d-xl-block d-lg-block"
                                : "sidebar-menu d-block d-xl-none d-lg-none"
                        }
                    >
                        <SideNavbar onClick={() => this.menuToggler()} />
                    </div>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper">
                        <Container fluid>
                            {/* Full-width profile — student-profile-page scopes the sp-*
                                styles + provides its own padding. */}
                            <div className="student-profile-page">
                            {/* Profile Header Card */}
                            <Card
                                className="border-0 mb-4"
                                style={{
                                    borderRadius: "20px",
                                    background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                                    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.04)",
                                    border: "1px solid rgba(226, 232, 240, 0.8)",
                                }}
                            >
                                <Card.Body className="p-4">
                                    <Row className="align-items-center">
                                        <Col xs="auto" className="mb-3 mb-md-0">
                                            {student?.profile_image_base ? (
                                                <img
                                                    src={student.profile_image_base}
                                                    alt={student?.student_name || "Profile"}
                                                    style={{
                                                        width: "95px",
                                                        height: "95px",
                                                        borderRadius: "20px",
                                                        objectFit: "cover",
                                                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
                                                        border: "3px solid #ffffff",
                                                    }}
                                                />
                                            ) : (
                                                <div
                                                    className="d-flex align-items-center justify-content-center text-white font-weight-bold"
                                                    style={{
                                                        width: "95px",
                                                        height: "95px",
                                                        borderRadius: "20px",
                                                        background:
                                                            "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                                                        fontSize: "2.5rem",
                                                        boxShadow: "0 8px 24px rgba(79, 70, 229, 0.2)",
                                                        border: "3px solid #ffffff",
                                                    }}
                                                >
                                                    {student && student.student_name
                                                        ? student.student_name.charAt(0).toUpperCase()
                                                        : "A"}
                                                </div>
                                            )}
                                        </Col>

                                        <Col className="flex-grow-1">
                                            <h3
                                                className="mb-0 font-weight-bold text-dark"
                                                style={{
                                                    fontFamily: "'Outfit', sans-serif",
                                                    fontSize: "28px",
                                                    letterSpacing: "-0.5px",
                                                }}
                                            >
                                                {student ? student.student_name : "Aarav Sharma"}
                                            </h3>
                                            <div
                                                className="d-flex flex-wrap align-items-center mt-2"
                                                style={{ gap: "8px" }}
                                            >
                                                <Badge
                                                    className="py-1.5 px-3"
                                                    style={{
                                                        backgroundColor: "#f0fdf4",
                                                        color: "#16a34a",
                                                        borderRadius: "30px",
                                                        fontWeight: "600",
                                                        fontSize: "12px",
                                                        border: "none",
                                                    }}
                                                >
                                                    {student && student.is_academic_exist
                                                        ? "Active"
                                                        : "Enrolled - Active"}
                                                </Badge>
                                                <Badge
                                                    className="py-1.5 px-3"
                                                    style={{
                                                        backgroundColor: "#eff6ff",
                                                        color: "#1d4ed8",
                                                        borderRadius: "30px",
                                                        fontWeight: "600",
                                                        fontSize: "12px",
                                                        border: "none",
                                                    }}
                                                >
                                                    {student
                                                        ? `Grade ${student.class_name || ""} - Section ${student.section_name || ""}`
                                                        : "Grade 6 - Section A"}
                                                </Badge>
                                                <Badge
                                                    className="py-1.5 px-3"
                                                    style={{
                                                        backgroundColor: "#f1f5f9",
                                                        color: "#475569",
                                                        borderRadius: "30px",
                                                        fontWeight: "600",
                                                        fontSize: "12px",
                                                        border: "none",
                                                    }}
                                                >
                                                    Roll No. {student ? student.roll_no : "42"}
                                                </Badge>
                                                <Badge
                                                    className="py-1.5 px-3"
                                                    style={{
                                                        backgroundColor: "#f1f5f9",
                                                        color: "#475569",
                                                        borderRadius: "30px",
                                                        fontWeight: "600",
                                                        fontSize: "12px",
                                                        border: "none",
                                                    }}
                                                >
                                                    DOB: {formattedDob}
                                                </Badge>
                                            </div>
                                        </Col>

                                        <Col xs="auto" className="d-flex justify-content-end align-items-center" style={{ gap: 12 }}>
                                            {/* Exam-stream selector (JEE Mains / Advanced) — drives every tab. */}
                                            {this.state.streamsLoaded && this.state.streamOptions.length > 1 && (() => {
                                                const selected = this.state.streamOptions.find((o) => o.value === this.state.examStream) || this.state.streamOptions[0] || { label: "", count: null };
                                                return (
                                                    <div className={`sp-stream-select ${this.state.streamMenuOpen ? "open" : ""}`} ref={(el) => { this.streamRef = el; }}>
                                                        <span className="sp-stream-label">Exam</span>
                                                        <button type="button" className="sp-stream-trigger" onClick={this.toggleStreamMenu}>
                                                            <span className="sp-stream-trigger-ic"><i className="fas fa-graduation-cap" /></span>
                                                            <span className="sp-stream-trigger-text">{selected.label}</span>
                                                            {selected.count != null ? <span className="sp-stream-trigger-count">{selected.count}</span> : null}
                                                            <i className="fas fa-chevron-down sp-stream-caret" />
                                                        </button>
                                                        {this.state.streamMenuOpen && (
                                                            <ul className="sp-stream-menu" role="listbox">
                                                                {this.state.streamOptions.map((opt) => {
                                                                    const active = this.state.examStream === opt.value;
                                                                    return (
                                                                        <li key={opt.value} role="option" aria-selected={active}>
                                                                            <button type="button" className={`sp-stream-item ${active ? "active" : ""}`} onClick={() => this.setStream(opt.value)}>
                                                                                <span className="sp-stream-item-ic"><i className="fas fa-graduation-cap" /></span>
                                                                                <span className="sp-stream-item-text">{opt.label}</span>
                                                                                {opt.count != null ? <span className="sp-stream-item-count">{opt.count} exams</span> : null}
                                                                                {active ? <i className="fas fa-check sp-stream-item-check" /> : null}
                                                                            </button>
                                                                        </li>
                                                                    );
                                                                })}
                                                            </ul>
                                                        )}
                                                    </div>
                                                );
                                            })()}
                                            {/* Full student report — downloads straight as a PDF. */}
                                            <button
                                                onClick={this.downloadReport}
                                                disabled={this.state.reportBusy}
                                                title="Download the full student report as a PDF"
                                                style={{
                                                    background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
                                                    border: "none",
                                                    color: "#ffffff",
                                                    borderRadius: "10px",
                                                    padding: "8px 18px",
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                    cursor: this.state.reportBusy ? "wait" : "pointer",
                                                    opacity: this.state.reportBusy ? 0.75 : 1,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    boxShadow: "0 6px 14px rgba(79, 70, 229, 0.25)",
                                                }}
                                            >
                                                <i className={this.state.reportBusy ? "fas fa-spinner fa-spin" : "fas fa-file-pdf"} />
                                                {this.state.reportBusy ? "Preparing…" : "Download Report"}
                                            </button>
                                            <button
                                                onClick={() => this.props.history.go(-1)}
                                                style={{
                                                    background: "#ffffff",
                                                    border: "1px solid #e2e8f0",
                                                    color: "#64748b",
                                                    borderRadius: "10px",
                                                    padding: "8px 18px",
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                }}
                                            >
                                                <i className="fas fa-arrow-left" /> Back
                                            </button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            {/* Grouped tab bar — student-app style (Individual Analysis / Records) */}
                            <div className="sp-tabs-card">
                                <div className="sp-tabs-groups">
                                    {GROUP_ORDER.map((groupName) => {
                                        const groupTabs = TABS.filter((t) => t.group === groupName);
                                        if (!groupTabs.length) return null;
                                        return (
                                            <div className="sp-tab-group" key={groupName}>
                                                <span className="sp-tab-group-label">{groupName}</span>
                                                <div className="sp-tab-group-items">
                                                    {groupTabs.map((tab) => (
                                                        <button
                                                            key={tab.key}
                                                            type="button"
                                                            className={`sp-tab-link ${activeTab === tab.key ? "active" : ""}`}
                                                            onClick={() => this.goToTab(tab.key)}
                                                        >
                                                            {tab.label}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* Tab Content — the ported tabs render their own sp-content-card,
                                so no extra wrapper (avoids double cards). */}
                            {this.renderTabContent(activeTab, student)}
                            </div>
                        </Container>
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withRouter(withApollo(StudentProfile1));
